import { ApiError } from '../errors/api-error.js';

export class VerbisApi {
    constructor(client) {
        this.client = client;
        this.basePath = '/verbis';
    }

    async getStatus() {
        try {
            const response = await this.client.get(`${this.basePath}/status`);
            return response.data;
        } catch (error) {
            throw ApiError.fromResponse(error);
        }
    }

    /** VERBİS bilgi seti (HTML blob). */
    async getExport() {
        try {
            const response = await this.client.get(`${this.basePath}/export`, { responseType: 'blob' });
            return response.data;
        } catch (error) {
            throw ApiError.fromResponse(error);
        }
    }

    async markSynced(data = {}) {
        try {
            const response = await this.client.post(`${this.basePath}/mark-synced`, data);
            return response.data;
        } catch (error) {
            throw ApiError.fromResponse(error);
        }
    }
}
